import type { ReactNode } from "react";
import { IconPlus } from "@tabler/icons-react";
import Button from "../Button";
import styles from "./HeaderLayout.module.css";
// @ts-expect-error pure js
import StandaloneTextInputGroup from "../StandaloneTextInputGroup";
import Title from "../Title.tsx";
import Text from "../Text.tsx";
import Breadcrumb, { type BreadcrumbItem } from "../Breadcrumb.tsx";

interface HeaderLayoutProps {
  title: string;
  /** Phrase d'accroche affichée sous le titre. */
  subtitle?: string;
  breadcrumb?: BreadcrumbItem[];
  searchPlaceholder?: string;
  onSearchChange?: (value: string) => void;
  addLabel?: string;
  onAdd?: () => void;
  /** Actions supplémentaires affichées à droite du titre (ex. tutos vidéo). */
  actions?: ReactNode;
}

export default function HeaderLayout({
  title,
  subtitle,
  breadcrumb,
  searchPlaceholder,
  onSearchChange,
  addLabel,
  onAdd,
  actions,
}: HeaderLayoutProps) {
  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          {breadcrumb && <Breadcrumb items={breadcrumb} />}
          <Title weight="bold">{title}</Title>
          {subtitle && <Text color="muted">{subtitle}</Text>}
        </div>
        <div className={styles.actions}>
          {actions}
          {onSearchChange && (
            <StandaloneTextInputGroup
              placeholder={searchPlaceholder}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onSearchChange(e.target.value.toLowerCase())
              }
            />
          )}
          {onAdd && (
            <Button icon={IconPlus} onClick={onAdd}>
              {addLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
